<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      rounded="sm"
      variant="transparent"
      style="height: 100%;"
      class="d-flex flex-column"
    >
      <div class="card resource-view__scrollable">
        <div style="padding-left: 18px; padding-top: 24px; display: flex;" v-if="document.signingOrder != null">
          <div v-if="document.signingOrder.status === 'COMPLETED'"
            style="background-color: rgb(61, 189, 90); width: 30px; margin-right: 12px; height: 30px; border-radius: 30px; display: flex; align-items: center; justify-content: center;">
            <feather-icon icon="CheckIcon" style="color: white"  size="19"/>
          </div>
          <div v-if="document.signingOrder.status === 'COMPLETED'">
            <h3 style="margin:0px">{{ $t('This Document is Signed') }}</h3>
            <p>{{ $t('All signers have signed this document through e-signing') }}</p>
          </div>
          <div v-else style="width: 100%; padding-right: 16px;">
            <div style="display: flex;">
              <div style="width: 100%;">
                <h3 style="margin:0px">{{ $t('This Document is Waiting For Signature') }}</h3>
                <p>{{ $t('Waiting for recipients to sign through e-signing') }}</p>
              </div>
              <div style="display: flex; justify-content: flex-end; width: 100%;">
                <button
                  id="cancel-sign-button" class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
                  @click="cancelSigning()">
                  <span>{{ $t('Cancel Signing') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="document-preview__upper-buttons mb-2 d-flex justify-content-between">
            <input
              ref="newFileInput"
              type="file"
              style="display: none"
              @change="handleNewFileInputChange"
            >
            <button
              id="create-button"
              :disabled="document.signingOrder != null"
              class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
              :class="{
                'icon-disabled': $can('Update', 'Document') === false
              }"
              @click="$can('Update', 'Document') && uploadNewVersion()"
            >
              <feather-icon
                icon="UploadIcon"
                class="mr-50"
              />
              <span>{{ $t('Upload new version') }}</span>
            </button>
            <b-tooltip target="create-button" v-if="document.signingOrder === null">
              {{ $can('Update', 'Document') === true ? $t('Upload new version') : $t('You dont have permission to uplaod new version') }}
            </b-tooltip>
            <b-tooltip target="create-button" v-if="document.signingOrder != null">
              {{ $t('Document update is disabled for this document') }}
            </b-tooltip>
            <div class="document-preview__select-version">
              <prozess-select
                v-model="selectedVersion"
                :placeholder="$t('Select version')"
                :options="previousVersions"
                :clearable="false"
                :reduce="option => option.value"
              />
            </div>
          </div>
          <div>
            <object
              v-if="$lodash.get(attachment, 'mimeType') === 'application/pdf'"
              ref="attachmentElement"
              style="width: 100%; height: 100vh"
              :data="attachment.url"
              type="application/pdf"
            />
            <div v-else>
              <p class="text-center mt-5">
                {{ $t('No preview available') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import documentService from '@/services/document'
import signicatService from '@/services/signicat'

export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      onCancel: false,
      currentVersion: null,
      attachment: null,
      selectedVersion: null,
    }
  },
  computed: {
    previousVersions() {
      return [
        { value: null, label: this.$t('Select version') },
        ...(this.document.versions || []).map(version => ({
          value: version.id,
          label: this.$d(new Date(version.uploadedTimestamp), 'long'),
        })),
      ]
    },
  },
  watch: {
    document: {
      handler(value) {
        this.selectedVersion = this.$lodash.get(value, 'versions.0.id')
        this.attachment = value.directUrlLatestVersion
      },
      immediate: true,
    },

    selectedVersion: {
      handler(value) {
        if (value) {
          this.getDirectUrl(value)
        }
      },

      immediate: true,
    },
  },
  methods: {
    async cancelSigning() {
      console.log('document.signingOrder', this.document.uuid)
      this.onCancel = true
      const canRes = await signicatService.cancelSigning(this.document.uuid)
      if (canRes.status === 200) {
        this.document.signingOrder = null
      }
      this.onCancel = false
    },
    handleNewFileInputChange(e) {
      const maxFileSize = 10
      const [file] = e.target.files
      if (file.size / 1024 / 1024 > maxFileSize) {
        this.$swal({
          title: `${this.$t('File should not exceed')} ${maxFileSize}mb`,
          icon: 'warning',
          confirmButtonText: this.$t('Close'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
          allowOutsideClick: false,
        })
      } else {
        this.upload(file)
      }
    },
    prepareFile(formName = 'form', file) {
      const formData = new FormData()
      delete this.document.mimeType
      this.document.fileName = file.name
      formData.append(formName, new Blob([JSON.stringify(this.document)], {
        type: 'application/json',
      }))
      formData.append('file', file)
      return formData
    },
    upload(file) {
      this.loading = true
      return documentService.updateWithNewFile(this.document.uuid, this.prepareFile('newVersionForm', file))
        .then(res => {
          this.$emit('update')
        })
        .finally(() => {
          this.loading = false
        })
    },
    uploadNewVersion() {
      this.$refs.newFileInput.click()
    },
    getDirectUrl(versionId) {
      this.loading = true
      setTimeout(() => {
        documentService.directUrl(this.document.uuid, versionId)
          .then(res => {
            this.attachment = res.data
            if (this.attachment.mimeType === 'application/pdf') {
              this.$refs.attachmentElement.data = this.attachment.url
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 3000)
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/company-contact-list.scss";

.document-preview {

  &__select-version {
    width: 240px;
    @media screen and (max-width: 425px) {
      margin-top: 1rem;
      width: 100%;
    }
  }

  &__upper-buttons {
    @media screen and (max-width: 425px) {
      flex-direction: column;
    }
  }
}
</style>
